import React, { useEffect } from 'react';
import {  shallowEqual, useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import Client from '../utils/network';
import { useDispatch } from 'react-redux';
import { setIds } from '../reducers/auth/authReducerActions';
import { createSelector } from '@reduxjs/toolkit';
import { authSelector } from '../reducers/auth/authReducer';

const selector = createSelector(
    [authSelector],
    (auth) => auth,
);

const ProtectedRoute = () => {

    const dispatch = useDispatch();



    const { isAuthenticated, channelId, guildId } = useSelector(selector, shallowEqual);


    useEffect(() => {
        if(isAuthenticated && (!channelId || !guildId)) {
            Client.request('/api/ids').then(async (ids) => {
                const { channelId, guildId } = await ids.json() as { channelId: string, guildId: string };
                dispatch(setIds(channelId, guildId));
                return;
            }).catch(() => {
                // nothing to do
            });
        }
    }, [isAuthenticated]);

    if (!isAuthenticated) {
        return <Navigate to="/" />;
    }
    return <Outlet />;
};

export default ProtectedRoute;
